export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/fission/cms-ordinary' */ './CmsOrdinary'
  );
